import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonItemSliding, IonList, ModalController} from '@ionic/angular';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {DocumentModel} from '../../models/document.model';
import {ReleaseSerialsService} from '../../services/release-serials.service';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {EquipmentSelect} from '../../modals/equipment-select/equipment-select';
import {BarcodescannerComponent} from '../../modals/barcodescanner/barcodescanner.component';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {AndroidPermissions} from '@ionic-native/android-permissions/ngx';
import {PicturesPermissionService} from '../../services/pictures-permission.service';
import {ProductMultiSelectComponent} from '../../modals/product-multi-select/product-multi-select.component';
import {EditProdQtyService} from '../../services/edit-prod-qty.service';
import {EquipmentMultiSelectComponent} from '../../modals/equipment-multi-select/equipment-multi-select.component';
import {ScannedTodayService} from '../../services/scanned-today.service';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {BarcodeOptions} from '../../definitions/barcode-options';
import {PersistScannedBarcodesService} from '../../services/persist-scanned-barcodes.service';
import {ScanBarcodeService} from '../../services/scan-barcode.service';
import {GeneralService} from '../../services/general.service';
import {FindEquipmentPriceService} from '../../services/find-equipment-price.service';
import { DocumentTypes } from 'src/app/definitions/document-types';
import { ItemsReturnComponent } from '../items-return/items-return.component';

@Component({
    selector: 'items',
    templateUrl: './items.component.html',
    styleUrls: ['./items.component.scss'],

})
export class ItemsComponent implements OnInit {

    @Input() document: DocumentModel;
    @Input() replacementItem: Boolean;
    detailLine: DetaillineDTOModel;
    mobileConfig: MobileConfigurationModel = new MobileConfigurationModel();
    @Input() readonly: boolean = false;

    constructor(private modalController: ModalController,
                private releaseSerials: ReleaseSerialsService,
                private alertController: AlertController,
                private androidPermissions: AndroidPermissions,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private picturesPermission: PicturesPermissionService,
                public editProdQtyService: EditProdQtyService,
                private barcodeScanner: BarcodeScanner,
                private barcodeOptions: BarcodeOptions,
                private persistScannedBarcodesService: PersistScannedBarcodesService,
                private scanBarcodeService: ScanBarcodeService,
                private docTypes: DocumentTypes,
                private generalService: GeneralService,
                private findEquipmentPriceService: FindEquipmentPriceService) {
    }

    ngOnInit() {
        this.mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
    }

    async equipProdModal(index: number, editItem: boolean) {
        // Edit item will set the modal to edit the item.
        let page = null;
        if (index === 1) {
            page = ProductMultiSelectComponent;
        } else if (index === 2) {
            if (this.document.documentType === this.docTypes.SERVICEJOB 
                || this.document.documentType === this.docTypes.CUSTOMERREPAIR 
                || this.document.documentType === this.docTypes.BREAKDOWN_COLLECTION ) {
                page = EquipmentSelect;
            } else {
                page = EquipmentMultiSelectComponent;
            }
        }
        const modal = await this.modalController.create({
            component: page,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'detailLine': this.detailLine,
                'document': this.document,
                'editItem': editItem,
                'replacementItem': this.replacementItem
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
            }
        });

        return await modal.present();
    }

    editDetailLine(det: DetaillineDTOModel) {
        this.detailLine = det;
        if (this.document.documentType === 8) {
            this.editItemQty(det);
            return;
        }
        if (det.pdesc) {
            this.equipProdModal(2, true);
        }
        if (det.plu) {
            this.equipProdModal(1, true);
        }
        this.detailLine = new DetaillineDTOModel();
    }

    async editItemQty(det: DetaillineDTOModel) {
        if (det.typ === 'M'
            || det.typ === 'P'
            || det.plu) {
            const qty = det.qty;
            const alert = await this.alertController.create({
                header: 'Edit Plant',
                backdropDismiss: false,
                message: 'Please adjust the quantity.',
                inputs: [
                    {
                        name: 'itemQty',
                        type: 'number',
                        value: qty,
                        placeholder: 'Enter new Qty'
                    }],
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    },
                    {
                        text: 'Ok',
                        handler: data => {
                            det.qty = data.itemQty;
                        }
                    }
                ]
            });

            await alert.present();

        } else {
            console.log(det.reg);
        }
    }

    deleteLine(i: number) {
        this.releaseSerials.updateSerialsFromDetailLine(this.document.detailLines[i]);
        this.document.detailLines.splice(i, 1);
    }

    async scanBarcode() {
        await this.picturesPermission.checkPermissions();
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {
            console.log(barcode.text);
            this.handleScanResult(barcode.text);
        }).catch(err => {
            console.log(err);
        });
        // const modal = await this.modalController.create({
        //     component: BarcodescannerComponent,
        //     cssClass: 'modal-fullscreen',
        //     componentProps: {
        //         'document': this.document
        //     }
        // });
        //
        // modal.onDidDismiss().then((dataReturned) => {
        //     if (dataReturned.data) {
        //     }
        // });
        // return await modal.present();
    }

    async handleScanResult(event) {
        console.log('Scan Result');
        console.log(event);
        let equipment = this.scanBarcodeService.findPlantItemByExactBarcode(event) as DetaillineDTOModel;
        if (equipment) {
            if (!equipment.qty) {
                equipment.qty = 1;
            }
            equipment = JSON.parse(JSON.stringify(equipment));
            await this.confirmEquipment(equipment);
        } else {
            await this.generalService.createToast('No match with barcode: ' + event);
        }
    }

    async confirmEquipment(equipment) {
        const alert = await this.alertController.create({
            header: 'Equipment found',
            message: 'Do you want to add \n' + equipment.description + '\nto the document?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, {
                    text: 'Yes',
                    handler: () => {
                        this.handleEquipmentFoundWithBarcode(equipment);
                    }
                }
            ]
        });
        await alert.present();
    }

    handleEquipmentFoundWithBarcode(equipment: any) {
        if (this.mobileConfig.mobilehireHealthCareInUse === 1) {
            if (this.document.parentDocument) {
                if (this.checkItemPresentInOrder(equipment)) {
                    this.checkSpecificFulfilment(equipment);
                } else {
                    this.generalService.createToast('Item not present in the order');
                }
            } else {
                const pushEquip = this.findEquipmentPriceService.getChargeLineAndDiscount(equipment, this.document.customer);
                pushEquip.fromDate = new Date().toISOString();
                pushEquip.toDate = new Date().toISOString();
                console.log('PushEquip');
                console.log(pushEquip);
                this.document.detailLines.push(pushEquip);
            }
        } else {
            // If it is a service job it behaves differently
            // It'll assign the equipement to the service job instead
            if (this.document.documentType === 7) {
                this.modalController.dismiss(equipment);
            } else {
                const pushEquip = this.findEquipmentPriceService.getChargeLineAndDiscount(equipment, this.document.customer);
                pushEquip.fromDate = new Date().toISOString();
                pushEquip.toDate = new Date().toISOString();
                console.log('PushEquip');
                console.log(pushEquip);
                if( this.document.documentType === this.docTypes.BREAKDOWN_COLLECTION ){
                    this.document.replacementItem = pushEquip;
                }else{
                    this.document.detailLines.push(pushEquip);
                }
                this.document.detailLines.push(pushEquip);
            }
        }
    }

    // async assignCustomer(equipment: DetaillineDTOModel) {
    //     this.document.customer = await this.stateManager.getCollection('customer').chain().find({id: equipment.custId}).data()[0];
    //     if (!this.document.customer) {
    //         this.document.customer = new CustomerModel();
    //     }
    // }

    checkItemPresentInOrder(tempEquip: DetaillineDTOModel): boolean {
        let itemPresent = false;
        for (const line of this.document.parentDocument.detailLines) {
            if (line.pdesc === tempEquip.pdesc) {
                itemPresent = true;
                break;
            }
        }
        return itemPresent;
    }

    private checkSpecificFulfilment(tempEquip: DetaillineDTOModel) {
        let itemFulfilled = false;
        for (const line of this.document.parentDocument.detailLines) {
            console.log(line);
            if (line.pdesc === tempEquip.pdesc && this.checkFulfillment(tempEquip) < line.qty) {
                const tempDetailLine = JSON.parse(JSON.stringify(line)) as DetaillineDTOModel;
                // tempDetailLine = this.findEquipmentPriceService.getChargeLineAndDiscount(line, this.document.customer);
                tempDetailLine.originalDetailLine = JSON.parse(JSON.stringify(line));
                tempDetailLine.documentNumber = null;
                tempDetailLine.detailLineId = 0;
                tempDetailLine.reg = tempEquip.reg;
                tempDetailLine.qty = 1;
                tempDetailLine.typ = tempEquip.typ;
                tempDetailLine.contractDocumentNumber = this.document.parentDocument.documentNumber;

                this.document.detailLines.push(tempDetailLine);
                itemFulfilled = true;
                break;
            }
        }
        if (!itemFulfilled) {
            this.generalService.createToast('Item already fulfilled');
        } else {
            this.checkIfOrderAlreadyFulfilled();
        }
    }

    checkFulfillment(item: DetaillineDTOModel) {
        let count = 0;
        for (const line of this.document.detailLines) {
            if (line.pdesc === item.pdesc) {
                count += line.qty;
            }
        }
        return count;
    }


    private checkIfOrderAlreadyFulfilled() {
        let fulfilled = true;
        for (const line of this.document.parentDocument.detailLines) {
            if (this.checkFulfillment(line) < line.qty) {
                fulfilled = false;
                break;
            }
        }
        //if (fulfilled) {
        //    this.modalController.dismiss();
        // }
    }


    handleChangeover(item: DetaillineDTOModel,newLine: DetaillineDTOModel,i: number){
        let originalDetailLine = JSON.parse( JSON.stringify(item) );
        let changeOverDetailLine = JSON.parse( JSON.stringify(item) );

        changeOverDetailLine.pdesc = newLine.pdesc;
        changeOverDetailLine.plantOrProductId = newLine.plantOrProductId;
        changeOverDetailLine.typ = newLine.typ;
        changeOverDetailLine.reg = newLine.reg;
        changeOverDetailLine.description = newLine.description;
        //if( originalDetailLine.changeOverDetailLine === null ){ // we only set the original line the first time we do a changeover, otherwise we would keep changing it
            originalDetailLine.changeOverDetailLine = changeOverDetailLine;
        //}
        
        this.document.detailLines.splice(i,1);

        this.document.detailLines.splice(i,0,originalDetailLine );

        
        
    }

    async openChangeoverEquipmentSearch(item: DetaillineDTOModel,i:number){
       
        console.log(item);

        let searchDocument = new DocumentModel();
        searchDocument.detailLines = [];
        searchDocument.scheduledDate = '1899-01-01 00:00:000';

        let detailLineDTO  = new DetaillineDTOModel();

        const modal = await this.modalController.create({
            component: EquipmentSelect,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': searchDocument,
                'detailLineDTO' : detailLineDTO
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
                if (dataReturned.data) {
                        console.log( "Plant Item  : " + dataReturned.data.pdesc + " / " + dataReturned.data.reg );
                  
                        this.handleChangeover(item,dataReturned.data,i);
                } 
            }
        );

        await modal.present();
    }


    clearChangeoverEquipment(item: DetaillineDTOModel,i:number){
        let originalDetailLine = JSON.parse( JSON.stringify(item) );
        originalDetailLine.changeOverDetailLine = null;

        this.document.detailLines.splice(i,1);
        this.document.detailLines.splice(i,0,originalDetailLine );
    }
}
